module.exports = __webpack_public_path__ + "img/autospin_btn.ea1dd228.png";